module.exports = __webpack_public_path__ + "static/img/bc_double.fe8d8cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bc_double.png
// module id = uFnz
// module chunks = 0